export { default as pick } from 'lodash.pick'
export { default as throttle } from 'lodash.throttle'
import { differenceInYears } from 'date-fns'
import Popper from 'popper.js'

export function calculateAge(dob, then = Date.now()) {
  return differenceInYears(then, dob)
}

export function bindForm(state, { path = [], redraw = false, onchange = null } = {}) {
  return function(e) {
    e.redraw = redraw
    const { target } = e
    if(!target.name) {
      if(isDev) console.warn('Name not found for target.', target)
      return
    }
    if(target.type === 'checkbox') {
      state.vm = i.setIn(state.vm, path.concat(target.name).concat(target.value || []), target.checked)
    } else {
      state.vm = i.setIn(state.vm, path.concat(target.name), target.value)
    }
    if(typeof onchange === 'function') onchange()
  }
}

export function oncreateorupdate(obj, fn) {
  if(arguments.length === 1) {
    fn = obj
    obj = {}
  }
  return Object.assign({}, obj, { oncreate: fn, onupdate: fn })
}

export function showSnack(msg, { style = true } = {}) {
  let elem, elemCreated = false
  if(typeof msg !== 'string') {
    elem = msg
  } else {
    elemCreated = true
    elem = document.createElement('div')
    elem.innerText = msg
    document.body.append(elem)
  }
  if(style) elem.classList.add(globalClasses.general.snack)
  const popper = new Popper({
    getBoundingClientRect: () => {
      const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      const centerWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) / 2
      return {
          top: height
          , bottom: height
          , left: centerWidth
          , right: centerWidth
      }
    }
  }, elem)
  res.popper = popper
  return res
  function res() {
    try {
      popper.destroy()
    } catch(e) {}
    try {
      if(elemCreated) elem.remove()
    } catch(e) {}
  }
}
